<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container grid-list-xl pt-0>
            <page-tool-bar show_search :loading="loader" :search.sync="search" :disabled="loader">
                <v-flex xs12 md2>
                    <div style="max-width: 290px" class="mr-3">
                        <v-menu :close-on-content-click="false" v-model="menu_month_picker" :nudge-right="40" lazy
                            transition="scale-transition" offset-y full-width min-width="290px" max-width="290px"
                            :disabled="loader">
                            <v-text-field slot="activator" v-model="chosen_month" label="Chọn tháng" :disabled="loader"
                                prepend-icon="event" readonly hide-details :loading="loader"></v-text-field>
                            <v-date-picker locale="vi-VI" type="month" v-model="chosen_month"
                                @input="menu_month_picker = false" :disabled="loader" :loading="loader"></v-date-picker>
                        </v-menu>
                    </div>
                </v-flex>
                <v-flex xs12 md2>
                    <div class="text-right d-flex align-center">
                        <v-select v-model="billType" :items="['Điện', 'Nước']" label="Chọn loại hóa đơn" outlined dense
                            hide-details class="mr-3" :disabled="loader" :loading="loader"></v-select>
                    </div>
                </v-flex>

                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="export_csv++" color="primary" dark :disabled="loader" :loading="loader">XUẤT EXCEL</v-btn>
                    </div>
                </v-flex>
            </page-tool-bar>

            <!-- Note Section -->
            <div style="max-width: 100%; width: 100%; gap: 8px; margin-bottom: 16px;">
                <v-textarea 
                    :key="textareaKey"
                    v-model="notes" 
                    placeholder="Nhập ghi chú..." 
                    dense 
                    rows="2" 
                    auto-grow 
                    outlined
                    style="flex: 1;"
                    :loading="notesLoading"
                    :disabled="notesLoading"
                ></v-textarea>

                <v-btn 
                    color="primary" 
                    @click="saveNotes"
                    :loading="notesLoading"
                    :disabled="notesLoading"
                >
                    Lưu ghi chú
                </v-btn>
            </div>
            <table-phan-tich-dien-nuoc-theo-thang :dateStart="date_start_computed" :dateEnd="date_end_computed"
                :billType="billType" :reloadTrigger="reload_table" :export_csv="export_csv" @loading="loader = $event" :chosen_month="chosen_month"></table-phan-tich-dien-nuoc-theo-thang>
        </v-container>
    </div>
</template>

<script>

import moment from 'moment'
import _ from 'lodash'
import TablePhanTichDienNuocTheoThang from './TablePhanTichDienNuocTheoThang.vue';
import api from 'Api';
import { buildParamQuery } from "Helpers";

export default {
    name: "phan-tich-dien-nuoc-theo-thang-layout",
    components: {
        TablePhanTichDienNuocTheoThang
    },
    data() {
        return {
            textareaKey: 0,
            reload_table: 0,
            download_csv_count: 0,
            loader: false,
            search: "",
            billType: 'Nước',
            chosen_month: moment().format('YYYY-MM'),
            menu_month_picker: false,
            export_csv: 0,
            notes: '',
            notesLoading: false,
        }
    },
    computed: {
        date_start_computed() {
            if (!this.chosen_month) return '';
            
            if (this.billType === 'Điện') {
                return `${this.chosen_month}-01`;
            } else {
                const previousMonth = moment(this.chosen_month, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
                return `${previousMonth}-12`;
            }
        },
        date_end_computed() {
            if (!this.chosen_month) return '';
            
            if (this.billType === 'Điện') {
                const [year, month] = this.chosen_month.split('-').map(Number);
                const lastDay = new Date(year, month, 0).getDate();
                return `${this.chosen_month}-${String(lastDay).padStart(2, '0')}`;
            } else {
                return `${this.chosen_month}-11`;
            }
        },
        typeCode() {
            return this.billType === 'Nước' ? 'W' : 'E';
        }
    },
    mounted() {
        this.fetchNotes()
        this.reload_table++

        this.debouncedResize = _.debounce(() => {
            this.textareaKey++
        }, 100)

        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    watch: {
        chosen_month() {
            this.reload_table++
        },
        billType() {
            this.reload_table++
        },
        search() {
            this.reload_table++
        },
        chosen_month() {
            this.fetchNotes()
        },
        billType() {
            this.fetchNotes()
        },
    },
    methods: {
        onResize() {
            this.debouncedResize()
        },
        async fetchNotes() {
            try {
                const params = {
                    month: this.chosen_month,
                    type: this.typeCode
                };

                const query = buildParamQuery(params);

                const response = await api.getWaterElectricityMonthlyReport(query);
                if (response.data && response.data.success) {
                    this.notes = response.data.data.notes || '';
                }
            } catch (error) {
                console.error('Lỗi khi lấy ghi chú:', error);
                this.notes = '';
            }
        },

        async saveNotes() {
            if (!this.chosen_month || !this.billType) return;
            
            this.notesLoading = true;
            try {
                const postData = {
                    month: this.chosen_month,
                    type: this.typeCode,
                    notes: this.notes
                };
                
                const response = await api.createOrUpdateWaterElectricityMonthlyReport(postData);
                if (response.data && response.data.success) {
                    swal.fire('Lưu ghi chú thành công', "", 'success')
                    this.fetchNotes();
                }
            } catch (error) {
                console.error('Lỗi khi lưu ghi chú:', error);
            } finally {
                this.notesLoading = false;
            }
        },
    },
}
</script>

<style scoped>
.v-select {
    max-width: 200px;
}
</style>
